export const adminData = state => {
    return state.adminData;
};

export const regimenData = state => {
    return state.regimenData;
};


export const editUserId = state => {
    return state.editUserId;
};
export const roles = state => {
    return state.roles;
};

export const adminUser = state => {
    return state.getUser;
}

export const noteData = state => {
    return state.notesData
}

export const insightData = state => {
    return state.insightData
}
export const deleteRegimenData = state => {
    return state.deleteRegimenData
}


// WEBPACK FOOTER //
// ./src/store/modules/admin/getters.js